export default __webpack_public_path__ + "static/media/order.a5f99911.svg";